// @flow

const MODULE_PATHS = ["/", "/analisis", "/portafolio"];

/**
 * True when navigation moves between Mis Mercados, Análisis and Portafolio.
 * Same path, login and logout do not count as a module change.
 */
export function isModulePathChange(
  previousPath: ?string,
  nextPath: ?string
): boolean {
  if (!previousPath || !nextPath || previousPath === nextPath) {
    return false;
  }
  return (
    MODULE_PATHS.indexOf(previousPath) !== -1 &&
    MODULE_PATHS.indexOf(nextPath) !== -1
  );
}
